// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__37JZD","BreadTop":"BurgerIngredient__BreadTop__1xvsr","Seeds1":"BurgerIngredient__Seeds1__1SXlR","Seeds2":"BurgerIngredient__Seeds2__3VxEN","Meat":"BurgerIngredient__Meat__1CvWv","Cheese":"BurgerIngredient__Cheese__6CCbZ","Salad":"BurgerIngredient__Salad__3HWpj","Bacon":"BurgerIngredient__Bacon__22pD7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngeredients/BurgerIngredient.css
// module id = 110
// module chunks = 3